import { adminInstance } from "@/api/instance";

export default async function (counselId, params) {
  return adminInstance.get(`/counsel/${counselId}`, { params });
}
